import script from "./DiffFileTree.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiffFileTree.vue?vue&type=script&lang=ts&setup=true"

import "./DiffFileTree.vue?vue&type=style&index=0&id=4f002b7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f002b7d"]])

export default __exports__